export default __webpack_public_path__ + "static/media/ISCO CLASS-9 EXAM PATTERN 2025.994038e9.pdf";